import React from 'react';
import { MetricsByCampaignGroupBarGraph } from '../../organisms/MetricsByCampaignGroupBarGraph';
import { MetricsByCampaignGroupTable } from '../../organisms/MetricsByCampaignGroupTable';

export const DeepDive: React.FC = () => {
  return (
    <>
      <MetricsByCampaignGroupBarGraph
        minH={400}
        title="Metrics overview"
        colSpan={12}
      />
      <MetricsByCampaignGroupTable
        title="Campaign Group explorer"
        colSpan={12}
      />
    </>
  );
};
